<template>
    <div class="editInfo">
        <div class="form">
            <p class="tips">{{titleText}}</p>
            <div class="inputView van-hairline--top-bottom">
                <input type="text" class="input" v-if="type === 'name'" v-model="form.name" placeholder="请输入姓名"/>
                <input type="text" class="input" v-if="type === 'selfArea'" v-model="form.selfArea" placeholder="请输入地址"/>
                <input type="text" class="input" v-if="type === 'selfCard'" v-model="form.selfCard" placeholder="请输入身份证"/>
                <template v-if="type === 'resetPS'">
                    <input type="password" class="input" v-model="resetPS.password" placeholder="请输入新密码" />
                    <div class="van-hairline--top" />
                    <input type="password" class="input" v-model="resetPS.reconfirm" placeholder="请再次输入新密码" />
                </template>
            </div>
            <p class="resetPSTips" v-if="type === 'resetPS'">
                密码重置后，旧密码将立即失效，同时需要使用新密码重新登录系统，请注意保管新密码。
            </p>
            <Button class="saveBtn" @click="save">保存</Button>
        </div>
    </div>
</template>

<script>
    /*
    * 修改用户信息
    * */
    import {Button} from 'vant'
    import {editInfoApi, resetPSApi} from "../../../../api/editInfo";

    export default {
        name: "EditInfo",
        components: {
            Button
        },
        data() {
            return {
                titleText: '请输入姓名，长度不能超过14字符',
                form: {
                    name: '',
                    selfCard: '',
                    selfArea: '',
                },
                resetPS: {
                    password: '',
                    reconfirm: ''
                },
                type: ''
            }
        },
        created() {
            let {type} = this.$route.params;
            let {value} = this.$route.query;
            this.type = type;
            switch (this.type) {
                case 'name':
                    this.form.name = value;
                    this.titleText = '请输入姓名，长度不能超过14字符';
                    break;
                case 'selfCard':
                    this.form.selfCard = value;
                    this.titleText = '请输入身份证号码，长度不能超过18字符';
                    break;
                case 'selfArea':
                    this.form.selfArea = value;
                    this.titleText = '请输入地址';
                    break;
                case 'resetPS':
                    this.titleText = '重置密码';
                    break;
            }
        },
        methods: {
            save() {
                let {type, form, resetPS} = this;
                // 重置密码
                if (type === 'resetPS') {
                    let {password, reconfirm} = resetPS;
                    if (!password) return this.toast({
                        text: '请输入新密码',
                        icon: 'warning'
                    });
                    if (!reconfirm) return this.toast({
                        text: '请再次输入新密码',
                        icon: 'warning'
                    });
                    if (reconfirm !== password) return this.toast({
                        text: '两次密码不一致',
                        icon: 'warning'
                    });
                    resetPSApi(resetPS).then(_ => {
                        this.$store.commit('SET_TOKEN', null);
                        this.toPage('/login', true);
                    });
                    return;
                }
                // 以下是修改用户的 姓名 地址 身份证号
                if (!form[type]) return this.toast({
                    text: '请输入信息',
                    icon: 'warning'
                });
                editInfoApi({[type] : form[type]}).then(res => {
                    this.alert({
                        text: '修改成功',
                        confirmButtonText: '返回',
                        fn: _ => {
                            this.$router.go(-1);
                        }
                    })
                })
            }
        }
    }
</script>

<style lang='less' scoped>
    .editInfo {
        min-height: 100vh;
        padding: 2.8vw 3.1vw 0;
        background-color: #f8f8f8;
        box-sizing: border-box;
        .resetPSTips {
            width: 84.8vw;
            margin: 4vw auto;
            font-size: 3.2vw;
            color: #131313;
        }
        .form {
            padding: 3.2vw 4vw 5.6vw;
            background-color: #ffffff;
            box-shadow: 0vw 0.5vw 1.3vw -0.5vw rgba(0, 0, 0, 0.08);
            border-radius: 2.7vw;
            .tips {
                font-size: 4vw;
                color: #333333;
            }
            .inputView {
                margin-top: 2.5vw;
                .input {
                    display: block;
                    width: 100%;
                    height: 8vw;
                    border: none;
                    font-size: 3.2vw;
                    &::placeholder {
                        font-size: 3.2vw;
                    }
                }
            }
            .saveBtn {
                display: block;
                width: 78.8vw;
                height: 11.3vw;
                margin: 4vw auto 0;
                line-height: 11.3vw;
                background-color: #43a2fe;
                border-radius: 5.7vw;
                font-size: 4vw;
                color: #ffffff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/setting/editInfo/EditInfo.vue